export const carouselSettings = {
  perPage: 5,
  perMove: 1,
  direction: 'rtl',
  drag: 'free',
  gap: '12px',
  pagination: false,
  lazyLoad: 'nearby',
  // fixedWidth: '280px',
  breakpoints: {
    380: {
      perPage: 2,
      perMove: 2,
    },
    434: {
      perPage: 2,
      perMove: 1,
    },
    464: {
      perPage: 2,
      perMove: 1,
    },
    768: {
      perPage: 2,
      perMove: 1,
    },
    992: {
      perPage: 3,
      perMove: 1,
    },
    1288: {
      perPage: 4,
      perMove: 1,
    },
  },
}

export default carouselSettings
